<template lang="pug">
#graficoProdutividade
    .select-culturas(v-if='culturaSelecionada')
        el-select(
            v-model='culturaSelecionada',
            placeholder='Select',
            size='mini',
            @change='updateGrafico'
        )
            el-option(
                v-for='item in tipoCulturas',
                :key='item.codigo',
                :label='item.nome',
                :value='item.codigo'
            )

    div(v-show='possuiProdutividade')
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='300',
            :options='options',
            :series='series',
            ref='chart'
        )

    div(v-show='!possuiProdutividade')
        empty-result(
            :min-height='150',
            icon-class='mdi-alert-octagon',
            :message='noResultMessage'
        )
</template>

<script>
import { graficoProdutividadeOptions } from '../../../utils/layouts/graficos';
import ApexCharts from 'vue-apexcharts';
import EmptyResult from '../../EmptyResult';

export default {
    name: 'GraficoProdutividade',

    components: {
        ApexCharts,
        EmptyResult
    },

    computed: {
        possuiProdutividade() {
            return this.dadosProdutividade && this.dadosProdutividade.length;
        },
        noResultMessage() {
            return this.$t('mensagens.monitoramento.historico.agricola.aindaNaoHaDadosDeProdutividade');
        }
    },
    data() {
        return {
            dadosProdutividade: null,
            dadosPrecipitacao: null,
            series: [],
            options: {
                legend: {
                    position: 'top'
                }
            },
            culturaSelecionada: null,
            tipoCulturas: null
        };
    },

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        },
        dadosMonitoramento: {
            type: Object,
            require: true
        },
        dadosPrecipitacaoSafraAtual: {
            type: Array
        }
    },

    methods: {
        configure() {
            const baseOptions = graficoProdutividadeOptions();
            this.options = Object.assign({}, baseOptions);

            this.dadosProdutividade = _.filter(
                this.dadosMonitoramento.monitoramentosProdutividadeEstimada,
                dp => {
                    return dp.cultura.codigo === this.culturaSelecionada;
                }
            );

            this.dadosProdutividade.forEach(d => {
                d.data = new Date(d.dataProcessamento);
            });
            this.dadosProdutividade = this.dadosProdutividade.sort(
                (a, b) => a.data - b.data
            );

            this.options.xaxis.categories = [];

            if (this.dadosProdutividade[0]) {
                this.dadosProdutividade[0].produtividade =
                    this.dadosProdutividade[0].produtividade.toFixed(2);
            }

            if (this.dadosProdutividade[2]) {
                this.dadosProdutividade[2].produtividade =
                    this.dadosProdutividade[2].produtividade.toFixed(2);
            }

            this.options.xaxis.categories.push(
                ...this.dadosProdutividade.map(dp =>
                    dp.data.toLocaleDateString('pt-BR')
                )
            );

            let prodEsperada = this.dadosProdutividade.map(
                d => d.produtividade
            );

            this.options.stroke.curve = [];

            this.options.stroke.curve[0] =
                prodEsperada.filter(Boolean).length !== 0 ? 'smooth' : '';

            this.series = [
                {
                    name: this.$t('mensagens.monitoramento.historico.agricola.produtividadeEstimada'),
                    type: 'line',
                    data: prodEsperada
                }
            ];

            this.$refs.chart.updateOptions(this.options);
        },

        setCulturaApresentacaoInicial() {
            let tipoCulturaInicial;

            if (!this.tipoCulturas || !this.tipoCulturas.length) return;

            tipoCulturaInicial = _.find(this.tipoCulturas, tc => {
                return tc.codigo === 'SOJA';
            });

            if (!tipoCulturaInicial) tipoCulturaInicial = this.tipoCulturas[0];

            this.culturaSelecionada = tipoCulturaInicial.codigo;
        },

        /* Cria novas listas apenas com as datas comuns entre NDVI e Precipitacao */
        agregarDatasProdutividadePrecipitacao() {
            let dadosProdutividade = [];
            let dadosPrecipitacao = [];

            this.dadosMonitoramento.monitoramentosProdutividadeEstimada.forEach(
                dadoProdutividade => {
                    for (
                        let precIndex = 0;
                        precIndex < this.dadosPrecipitacaoSafraAtual.length;
                        precIndex++
                    ) {
                        const dadoPrecipitacao =
                            this.dadosPrecipitacaoSafraAtual[precIndex];
                        if (
                            dadoProdutividade.dataProcessamento ===
                            dadoPrecipitacao.data
                        ) {
                            dadosProdutividade.push(dadoProdutividade);
                            dadosPrecipitacao.push(dadoPrecipitacao);
                            break;
                        }
                    }
                }
            );

            this.dadosProdutividade = dadosProdutividade;
            this.dadosPrecipitacao = dadosPrecipitacao;
        },

        updateGrafico(itemSelecionado) {
            this.culturaSelecionada = itemSelecionado;
            this.configure();
        },

        configureCulturasDisponiveis() {
            if (!this.dadosMonitoramento.monitoramentosProdutividadeEstimada) { return null; }

            let culturas = _.flatMap(
                _.uniqBy(
                    this.dadosMonitoramento.monitoramentosProdutividadeEstimada,
                    function (e) {
                        return e.cultura.codigo;
                    }
                ),
                e => {
                    return e.cultura;
                }
            );

            this.tipoCulturas = culturas;
        }
    },

    mounted() {
        this.configureCulturasDisponiveis();

        this.setCulturaApresentacaoInicial();

        this.configure();
    }
};
</script>

<style lang="scss" scoped>
.select-culturas {
    position: absolute;
    right: 60px;
    top: 25px;
    font-weight: normal;
}
.apexcharts-tooltip {
    background-color: white;
    border: 1px solid #e3e3e3;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    padding: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
    background: #fff !important;
    align-self: flex-start;
    font-family: Arial, Helvetica, sans-serif;
    color: #333;
    border-bottom: 0px !important;
    font-weight: 600;
    font-size: 14px !important;
    padding: 5px;
    border-radius: 5px 5px 0 0;
}

.apexcharts-tooltip .apexcharts-tooltip-series-group {
    padding: 5px;
    display: flex;
    align-items: center;
}

.apexcharts-tooltip .apexcharts-tooltip-marker {
    width: 10px;
    height: 10px;
    margin-right: 5px;
}

.apexcharts-tooltip .apexcharts-tooltip-text {
    font-size: 12px;
    color: #333;
}

.apexcharts-tooltip .apexcharts-tooltip-text-y-label,
.apexcharts-tooltip .apexcharts-tooltip-text-y-value {
    display: inline-block;
}
</style>
